import { render, staticRenderFns } from "./relateEmpoyee.vue?vue&type=template&id=6f314daa&scoped=true&"
import script from "./relateEmpoyee.vue?vue&type=script&lang=js&"
export * from "./relateEmpoyee.vue?vue&type=script&lang=js&"
import style0 from "./relateEmpoyee.vue?vue&type=style&index=0&id=6f314daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f314daa",
  null
  
)

export default component.exports